import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import CardCarousel from 'components/consumer/image-slider-standard/components/CardCarousel';
import { fetchPostsByCategory } from 'lib/contentful-client';
import ToggleCTALinkButton from 'components/essentials/ToggleCTALinkButton';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import BlogSlideComponent from './BlogSlideComponent';

const blogUrl = '/blog/';
const ConsumerBlogSlider = ({
  config: { heading, subHeading, toggleInputType },
  isAdmin,
}) => {
  const isSubHeading = subHeading && subHeading.content;
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    if (isAdmin) {
      return;
    }

    fetchPostsByCategory(
      blogUrl,
      'the-latest',
      20,
      0,
      'fields.slug,fields.title,fields.featuredImage'
    )
      .then(result => {
        if (
          result?.posts &&
          Array.isArray(result.posts) &&
          result.posts.length > 0
        ) {
          const posts = result.posts.map(post => ({
            title: post.title,
            slug: post.slug,
            image: `https:${post.featuredImage.fields.file.url.replace(
              'downloads.ctfassets.net',
              'images.ctfassets.net'
            )}`,
          }));
          setBlogs(posts);
        } else {
          setBlogs([]);
        }
      })
      .catch(() => {
        setBlogs([]);
      });
  }, [isAdmin]);

  if (isAdmin) {
    return (
      <AdminPlaceholder className="!min-h-[500px]">
        Consumer Blog Slide: Contentful API Blog Component Placeholder for
        Variant Builder. <br />
        The component will display correctly in Consumer
      </AdminPlaceholder>
    );
  }

  const children = blogs.map(blog => (
    <BlogSlideComponent
      image={blog.image}
      title={blog.title}
      key={blog.slug}
      link={`${blog.slug}`}
    />
  ));

  return (
    <FixedWidthContainer noMobilePadding>
      <div className="min-h-[440px] mx-0 my-6 [&_a]:no-underline [&_p]:text-lg [&_p]:text-gray [&_p]:mt-[22px] [&_p]:mb-6 [&_.slider-control-centerright]:!top-[35%] [&_.slider-control-centerleft]:!top-[35%] [&_.slider-control-centerleft]:!left-[3px] [&_.slider-control-centerright]:!right-[3px]">
        <h2 className="max-[767px]:pl-5 max-[767px]:pr-5 m-0 text-2xl font-bold">
          {(heading && heading.content) || ''}
        </h2>
        {isSubHeading && (
          <p className="max-[767px]:pl-5 max-[767px]:pr-5 font-normal subHeading">
            {subHeading.content}
          </p>
        )}
        <CardCarousel
          imageHeight={340}
          imageWidth={340}
          navType="Button"
          variant="blog-slider"
          visibleSlides={4}
        >
          {children}
        </CardCarousel>
        {!!toggleInputType && (
          <div className="max-[767px]:pl-5 max-[767px]:pr-5">
            <ToggleCTALinkButton
              toggleInputType={toggleInputType}
              noHorizontalPadding
            />
          </div>
        )}
      </div>
    </FixedWidthContainer>
  );
};

ConsumerBlogSlider.propTypes = {
  isAdmin: PropTypes.string,
  config: PropTypes.object,
};

export default ConsumerBlogSlider;
